import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  Box,
  FormControlLabel,
  RadioGroup,
  Checkbox,
  Button,
} from '@material-ui/core'
import clsx from 'clsx'
import Grid from '@material-ui/core/Grid'
import { green } from '@material-ui/core/colors'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import {
  image,
  Specifications,
  ActiveLinkTypeDnaplate,
  PlateProduct,
} from '../enum'
import {
  usePlateSessionFieldMutation,
  usePlateTotalValidationMutation,
  useValidatePlateShippingMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useGetPlatePriceCallLazyQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import { configContext } from '../DnaPlates'
import { dnaPlatesRoute, useRouter } from '@src/routes'
import { Formik, Field, Form } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import CircleLoader from '@src/components/CircleLoader'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import { TubeProperties } from '../../../utils/enum'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { isIEBrowser } from '../../../utils/util'
import styles from '@src/routes/Configurators/utils/styles'

const useStyles = makeStyles((theme: Theme) => ({
  contentWrapper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 5),
  },
  dFlexDirectionRowReverse: {
    flexDirection: 'row-reverse',
  },
  dFlex: {
    display: 'flex',
  },
  plateType: {
    marginTop: theme.spacing(6),
  },
  font1: {
    fontSize: theme.typography.pxToRem(12),
    marginLeft: theme.spacing(9),
  },
  mgleft: {
    marginLeft: theme.spacing(5),
  },
  leftSpace: {
    paddingLeft: theme.spacing(4),
  },
  radio: {
    color: green[400],
    '&$checked': {
      color: green[600],
      margingLeft: theme.spacing(8),
    },
  },
  labelFont: {
    '& .MuiTypography-body1': {
      fontSize: 14,
    },
  },
  w100: {
    width: '100%',
  },
  continueButton: {
    width: theme.spacing(50),
  },
  mgBottom3: {
    marginBottom: theme.spacing(5),
  },
  mgTop: {
    marginTop: theme.spacing(5),
  },
  font12: {
    fontSize: theme.typography.pxToRem(12),
    paddingLeft: theme.spacing(2),
  },
  subHead: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(3, 0),
    paddingLeft: theme.spacing(2),
  },
  colorRed: {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(13),
  },
  hideRow: {
    display: 'none',
  },
  errormsg: {
    marginLeft: theme.spacing(5),
  },
  otherInput: {
    width: theme.spacing(30),
    height: theme.spacing(8),
  },
  radioButtons: {
    width: theme.spacing(75),
  },
  over1: {
    fontSize: theme.typography.pxToRem(14),
    color: '#1d5293',
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(2),
  },
  overrideCheckBox: {
    padding: theme.spacing(0),
  },
  mgBottomexcess: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(4),
    margin: theme.spacing(8, 0, 3, 0),
  },
  textBoxGrid: {
    marginTop: theme.spacing(1),
  },
  othertextBoxIE: {
    marginLeft: theme.spacing(21),
  },
  constrainImageToBox: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}))

const PlateType = (props) => {
  const classes = useStyles()
  const globalClasses = styles()
  const { specificationsData, productDetails } = props
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, isPageLoad } = state
  const [platesessionField, { loading: saveSessionLoading }] =
    usePlateSessionFieldMutation()
  const [plateTotalValidation, { loading: totalValidationLoading }] =
    usePlateTotalValidationMutation()
  const [validateplateShipping, { loading: shippingLoading }] =
    useValidatePlateShippingMutation()
  const [plateType, setPlateType] = React.useState(
    sessionData[0].selectedPackageType
  )
  const [shipping, setShipping] = React.useState(sessionData[0].shipping)
  const [saveToSession, setSaveToSession] = React.useState(false)
  const [stockPlate, setStockPlate] = React.useState(
    sessionData[0].category === Specifications.No
      ? ''
      : sessionData[0].stockPlate === ''
        ? 'N'
        : sessionData[0].stockPlate
  )
  const [isOverriden, setIsOverriden] = React.useState(
    sessionData[0].isShippingOverridden
  )
  const [packageTypeText, setPackageTypeText] = React.useState(
    sessionData[0].isPackageTypeOther ? sessionData[0].packageType : ''
  )
  const [recommendationText, setRecommendationText] = React.useState(
    sessionData[0].format !== Specifications.DRY &&
      sessionData[0].wellType === PlateProduct.wellType96 &&
      sessionData[0].category === Specifications.No
      ? true
      : false
  )
  const [callPackageOthersDebounce, setCallPackageOthersDebounce] =
    React.useState(false)
  const debouncedPackageOthers = useDebounce(
    packageTypeText,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [getPriceData, { data, loading: priceLoading }] =
    useGetPlatePriceCallLazyQuery()

  const fetchPriceData = async (obj) => {
    await getPriceData({
      variables: { product: obj },
    })
  }

  React.useEffect(() => {
    if (isPageLoad) {
      setPlateType(sessionData[0].selectedPackageType)
      setShipping(sessionData[0].shipping)
      setStockPlate(
        sessionData[0].category === Specifications.No
          ? ''
          : sessionData[0].stockPlate === ''
            ? 'N'
            : sessionData[0].stockPlate
      )
      setIsOverriden(sessionData[0].isShippingOverridden)
      setPackageTypeText(
        sessionData[0].isPackageTypeOther ? sessionData[0].packageType : ''
      )
      setSaveToSession(true)
      setRecommendationText(
        sessionData[0].format !== Specifications.DRY &&
          sessionData[0].wellType === PlateProduct.wellType96 &&
          sessionData[0].category === Specifications.No
          ? true
          : false
      )
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageLoad])

  React.useEffect(() => {
    if (
      data !== undefined &&
      !data.getPlatePriceCall?.serverError &&
      data.getPlatePriceCall?.response !== null
    ) {
      dispatch({
        type: 'UPDATE_PLATE_PRICE',
        data: data.getPlatePriceCall?.response,
      })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }
  const [requiredPlateType, setRequiredPlateType] = React.useState(false)
  const [requiredShipping, setRequiredShipping] = React.useState(false)
  const router = useRouter()
  const intl = useIntl()
  const isIE = isIEBrowser()

  const checkRequiredFields = (error) => {
    error.forEach((obj) => {
      if (
        obj.key === Specifications.packagetype ||
        obj.key === Specifications.packageType
      ) {
        setRequiredPlateType(true)
      }
      if (obj.key === Specifications.shipping) {
        setRequiredShipping(true)
      }
    })
  }
  const plateShippingValidation = async (sessionData) => {
    const response: any = await validateplateShipping({
      variables: { input: sessionData, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.validatePlateShipping.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_VALIDATE_PLATE_SHIPPING',
        data: data.validatePlateShipping,
      })
      if (
        sessionData[0].wellType === PlateProduct.wellType &&
        sessionData[0].selectedPackageType !== Specifications.PackageTypeOther
      ) {
        sessionData.forEach((session) => {
          session.packageType = Specifications.Shallow_well_40
          session.selectedPackageType = Specifications.Shallow_well_40
          session.isPackageTypeOther = false
          session.wellList.forEach((well) => {
            well.packageType = Specifications.Shallow_well_40
          })
        })
        setPlateType(Specifications.Shallow_well_40)
      }
      if (sessionData[0].isShippingOverridden !== true) {
        if (data.validatePlateShipping.listShipment.length === 1) {
          sessionData.forEach((session) => {
            session.shipping = data.validatePlateShipping.listShipment[0]
            session.wellList.forEach((well) => {
              well.shipping = data.validatePlateShipping.listShipment[0]
            })
          })
          setShipping(data.validatePlateShipping.listShipment[0])
        }
        if (data.validatePlateShipping.listProductPackage.length === 1) {
          sessionData.forEach((session) => {
            session.packageType =
              data.validatePlateShipping.listProductPackage[0]
            session.selectedPackageType =
              data.validatePlateShipping.listProductPackage[0]
            session.isPackageTypeOther = false
            session.wellList.forEach((well) => {
              well.packageType =
                data.validatePlateShipping.listProductPackage[0]
            })
          })
          setPlateType(data.validatePlateShipping.listProductPackage[0])
        }
        if (
          data.validatePlateShipping.listProductPackage.length === 2 &&
          data.validatePlateShipping.listProductPackage.includes(
            Specifications.PackageTypeOther
          ) &&
          sessionData[0].selectedPackageType !== Specifications.PackageTypeOther
        ) {
          sessionData.forEach((session) => {
            session.packageType =
              data.validatePlateShipping.listProductPackage[0]
            session.selectedPackageType =
              data.validatePlateShipping.listProductPackage[0]
            session.isPackageTypeOther = false
            session.wellList.forEach((well) => {
              well.packageType =
                data.validatePlateShipping.listProductPackage[0]
            })
          })
          setPlateType(data.validatePlateShipping.listProductPackage[0])
        }
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    savePlateDataToSession(sessionData)
  }
  const totalValidation = async () => {
    const response: any = await plateTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    const { data } = response
    let errorCount = 0
    if (data && !data.plateTotalValidation.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: data.plateTotalValidation.response,
      })
      data.plateTotalValidation.response.forEach((plate) => {
        plate.wellList.forEach((well) => {
          if (well.listError.length !== 0) {
            errorCount = errorCount + 1
          }
        })
      })
      if (errorCount !== 0) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        checkRequiredFields(
          data.plateTotalValidation.response[0].wellList[0].listError
        )
        window.scrollTo(0, 0)
        sessionData.forEach((data) => {
          data.pageNo = 3
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        dispatch({ type: 'SET_STEP_NO', data: 3 })
      } else {
        dispatch({ type: 'SET_STEP_NO', data: 4 })
        const url = `${dnaPlatesRoute.index()}?product=${
          productDetails.productType
        }&activeLink=${ActiveLinkTypeDnaplate.OrderConfirmation}`
        router.push(url)
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    savePlateDataToSession(sessionData)
  }

  const goToNextStep4 = () => {
    if (
      sessionData[0].isPackageTypeOther &&
      sessionData[0].packageType.length === 0
    ) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
      setRequiredPlateType(true)
      window.scrollTo(0, 0)
    } else {
      sessionData.forEach((data) => {
        data.pageNo = 4
        delete data.__typename
        data.wellList.forEach((well) => {
          if (data.isShippingOverridden !== true) {
            well.pageNo = 4
          } else {
            well.pageNo = 0
          }
          delete well.__typename
          well.listError.forEach((error) => {
            delete error.__typename
          })
        })
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      totalValidation()
      fetchPriceData(productDetails)
    }
  }
  React.useEffect(() => {
    if (saveToSession) {
      sessionData.forEach((session) => {
        if (plateType === Specifications.PackageTypeOther) {
          session.packageType = packageTypeText.trim()
          session.isPackageTypeOther = true
        } else {
          session.isPackageTypeOther = false
          session.packageType = plateType
        }
        session.shipping = shipping
        session.stockPlate = stockPlate
        session.selectedPackageType = plateType
        session.isShippingOverridden = isOverriden
        session.wellList.forEach((well) => {
          if (plateType === Specifications.PackageTypeOther) {
            well.packageType = packageTypeText.trim()
          } else {
            well.packageType = plateType
          }
          well.shipping = shipping
          if (stockPlate === 'Y') {
            well.excessMaterial = true
          } else {
            well.excessMaterial = false
          }
          well.listError = []
        })
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      plateShippingValidation(sessionData)
      setSaveToSession(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveToSession])

  React.useEffect(
    () => {
      if (callPackageOthersDebounce) {
        setCallPackageOthersDebounce(false)
        if (sessionData[0].isPackageTypeOther) {
          sessionData.forEach((data) => {
            data.packageType = debouncedPackageOthers.trim()
            data.wellList.forEach((well) => {
              well.packageType = debouncedPackageOthers.trim()
            })
          })
          dispatch({
            type: 'UPDATE_INPUT',
            data: [...state.sessionData],
          })
          savePlateDataToSession(sessionData)
        }
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedPackageOthers]
  )

  const handlerChange = (e, type) => {
    sessionData.forEach((data) => {
      data.pageNo = 3
    })
    dispatch({ type: 'SET_STEP_NO', data: 3 })
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    if (
      type === Specifications.packagetype96 ||
      type === Specifications.packagetype384
    ) {
      setPlateType(e.target.value)
      setRequiredPlateType(false)
      setSaveToSession(true)
    }
    if (type === Specifications.shipping) {
      setShipping(e.target.value)
      setRequiredShipping(false)
      setSaveToSession(true)
    }
    if (type === Specifications.excessmaterial) {
      setStockPlate(e.target.value)
      setSaveToSession(true)
    }
    if (type === Specifications.PackageTypeOther) {
      setCallPackageOthersDebounce(true)
      setPackageTypeText(e.target.value)
      if (plateType.length !== 0) {
        setRequiredPlateType(false)
      }
    }
  }

  const handleOverride = (value) => {
    sessionData.forEach((data) => {
      data.pageNo = 3
    })
    dispatch({ type: 'SET_STEP_NO', data: 3 })
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setRequiredPlateType(false)
    setRequiredShipping(false)
    setIsOverriden(value)
    setSaveToSession(true)
  }
  const disablingRadioButton = (data, categoryName) => {
    if (state.plateShippingResponse !== null) {
      let list: any = []

      switch (categoryName) {
        case Specifications.packagetype96: {
          list = state.plateShippingResponse.listProductPackage
          break
        }
        case Specifications.packagetype384: {
          list = state.plateShippingResponse.listProductPackage
          break
        }
        case Specifications.shipping: {
          list = state.plateShippingResponse.listShipment
          break
        }
        default:
          return false
      }
      if (list === null) {
        return true
      } else if (list.includes(data.value)) {
        return false
      }
    }
    return true
  }
  const specificationData = (specificationsData, specificationType) => {
    return specificationsData.specificationModifications.map(
      (plateTypes, index) => {
        let img = plateTypes.value
        img += image.png
        return (
          <>
            <Grid className={clsx(classes.plateType, classes.mgleft)}>
              {plateTypes.value !== Specifications.PackageTypeOther ? (
                <>
                  <FormControlLabel
                    key={index}
                    value={plateTypes.value}
                    control={
                      <StyledRadio
                        isConfiguratorsRedesign="true"
                        onChange={(e) => handlerChange(e, specificationType)}
                      />
                    }
                    className={classes.labelFont}
                    label={
                      messages[plateTypes.displayName]?.defaultMessage ||
                      plateTypes.displayName
                    }
                    disabled={
                      isOverriden === true
                        ? false
                        : disablingRadioButton(plateTypes, specificationType)
                    }
                  />
                  <Box display="flex" component="a">
                    <Box
                      height={{ xs: 150, sm: 150 }}
                      width={{ xs: 114, sm: 160 }}
                    >
                      <img
                        className={classes.constrainImageToBox}
                        alt="scale"
                        src={`/static/${img}`}
                      />
                    </Box>
                  </Box>
                </>
              ) : (
                <Grid container>
                  <Grid item xs={5} sm={5}>
                    <FormControlLabel
                      key={index}
                      value={plateTypes.value}
                      control={
                        <StyledRadio
                          isConfiguratorsRedesign="true"
                          onChange={(e) => handlerChange(e, specificationType)}
                        />
                      }
                      className={classes.labelFont}
                      label={
                        messages[plateTypes.displayName]?.defaultMessage ||
                        plateTypes.displayName
                      }
                      disabled={
                        isOverriden === true
                          ? false
                          : disablingRadioButton(plateTypes, specificationType)
                      }
                    />
                  </Grid>
                  <Grid xs={7} sm={7} className={classes.textBoxGrid}>
                    <Formik
                      initialValues={{ addInfo: '' }}
                      validateOnChange
                      onSubmit={(values, actions) => {
                        setTimeout(() => {
                          actions.setSubmitting(false)
                        }, 1000)
                      }}
                    >
                      {() => {
                        return (
                          <Form>
                            <Field
                              name="other"
                              size="small"
                              fullWidth={false}
                              value={packageTypeText}
                              onChange={(e) => {
                                handlerChange(
                                  e,
                                  Specifications.PackageTypeOther
                                )
                              }}
                              component={LiquidInputAdapter}
                              filled
                              className={clsx(
                                classes.otherInput,
                                isIE ? classes.othertextBoxIE : ''
                              )}
                              disabled={
                                isOverriden === true
                                  ? false
                                  : disablingRadioButton(
                                      plateTypes,
                                      specificationType
                                    )
                              }
                            />
                          </Form>
                        )
                      }}
                    </Formik>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </>
        )
      }
    )
  }

  const populatePlateType = (specificationsData, specificationType) => {
    return specificationsData.specifications.map((specificationList, index) => {
      if (specificationList.categoryName === specificationType) {
        return (
          <RadioGroup
            aria-label="plateType"
            name="plateType"
            value={
              sessionData[0].isPackageTypeOther
                ? sessionData[0].selectedPackageType
                : sessionData[0][Specifications.packageType]
            }
            row
            key={index}
          >
            {specificationData(specificationList, specificationType)}
          </RadioGroup>
        )
      } else {
        return <></>
      }
    })
  }
  const specificationDataShipping = (specificationsData, specificationType) => {
    return specificationsData.specificationModifications.map(
      (shipping, index) => {
        return (
          <FormControlLabel
            key={index}
            value={shipping.value}
            control={
              <StyledRadio
                isConfiguratorsRedesign="true"
                onChange={(e) => handlerChange(e, specificationType)}
              />
            }
            className={classes.font12}
            label={
              messages[shipping.displayName]?.defaultMessage ||
              shipping.displayName
            }
            disabled={
              isOverriden === true
                ? false
                : disablingRadioButton(shipping, specificationType)
            }
          />
        )
      }
    )
  }
  const populateShipping = (specificationsData, specificationType) => {
    return specificationsData.specifications.map((specificationList, index) => {
      if (specificationList.categoryName === specificationType) {
        return (
          <RadioGroup
            aria-label="shipping"
            name="shipping"
            value={sessionData[0][specificationType]}
            key={index}
            className={classes.radioButtons}
          >
            {specificationDataShipping(specificationList, specificationType)}
          </RadioGroup>
        )
      } else {
        return <></>
      }
    })
  }
  return (
    <>
      <div
        className={clsx(
          classes.contentWrapper,
          classes.dFlexDirectionRowReverse
        )}
      >
        <Grid container>
          <Grid item xs={9}>
            <h2 className={classes.leftSpace}>
              <FormattedMessage {...messages.CONF_DNAPLATES_PACKING_SHIPPING} />
            </h2>
          </Grid>
          <Grid item xs={3}>
            {productDetails.isCSRSupervisor === true ? (
              <FormControlLabel
                classes={{ label: classes.over1 }}
                control={
                  <Checkbox
                    value={isOverriden}
                    color="primary"
                    checked={isOverriden}
                    onChange={() => {
                      handleOverride(!isOverriden)
                    }}
                    className={classes.overrideCheckBox}
                  />
                }
                label={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
              />
            ) : (
              ''
            )}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} className={classes.plateType}>
            <strong className={classes.leftSpace}>
              <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_TYPE} />
            </strong>
          </Grid>
        </Grid>
        <Grid container>
          {sessionData[0].wellType === 96
            ? populatePlateType(
                specificationsData,
                Specifications.packagetype96
              )
            : populatePlateType(
                specificationsData,
                Specifications.packagetype384
              )}
        </Grid>
        <Grid className={requiredPlateType ? '' : classes.hideRow}>
          <div className={clsx(classes.colorRed, classes.errormsg)}>
            <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
          </div>
        </Grid>
      </div>
      <div>
        <Grid container className={recommendationText ? '' : classes.hideRow}>
          <Grid
            item
            xs={12}
            className={clsx(classes.plateType, globalClasses.paddingLeft9)}
          >
            <strong>
              <FormattedMessage
                {...messages.CONF_DNAPLATES_RECOMMENDATION_TEXT}
              />
            </strong>
          </Grid>
        </Grid>
      </div>
      <div className={clsx(classes.contentWrapper, classes.dFlex)}>
        <Box>
          <div className={classes.w100}>
            <div className={clsx(classes.mgBottom3, classes.font12)}>
              <h2 className={classes.subHead}>
                <FormattedMessage
                  {...messages.CONF_SHIPPING_OPTION_DNA_PLATES}
                />
              </h2>
            </div>
            <div className={classes.font12}>
              {populateShipping(specificationsData, Specifications.shipping)}
              <Grid className={requiredShipping ? '' : classes.hideRow}>
                <div className={clsx(classes.colorRed, classes.errormsg)}>
                  <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
                </div>
              </Grid>
            </div>
            {sessionData[0].category === Specifications.No ? (
              ''
            ) : (
              <>
                <div className={classes.mgBottomexcess}>
                  <FormattedMessage
                    {...messages.CONF_OLIGO_MATERIAL_DNA_PLATES}
                  />
                </div>
                <div className={classes.font12}>
                  <RadioGroup
                    aria-label="stockPlate"
                    name="stockPlate"
                    value={stockPlate}
                  >
                    <FormControlLabel
                      value="N"
                      control={
                        <StyledRadio
                          isConfiguratorsRedesign="true"
                          onChange={(e) =>
                            handlerChange(e, Specifications.excessmaterial)
                          }
                        />
                      }
                      className={classes.font12}
                      label={intl.formatMessage(
                        messages._PC_PLATE_SH_No_dnaplate
                      )}
                    />
                    <FormControlLabel
                      value="Y"
                      control={
                        <StyledRadio
                          isConfiguratorsRedesign="true"
                          onChange={(e) =>
                            handlerChange(e, Specifications.excessmaterial)
                          }
                        />
                      }
                      className={classes.font12}
                      label={intl.formatMessage(
                        messages._PC_PLATE_SH_Yes_dnaplate
                      )}
                    />
                  </RadioGroup>
                </div>
              </>
            )}
          </div>
        </Box>
      </div>
      <div className={clsx(classes.mgTop)}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.continueButton}
          onClick={goToNextStep4}
          id="plates-continue-button-3"
          data-testid="plates-continue-button-3"
        >
          <FormattedMessage {...messages.CONF_CONTINUE_DNA_PLATES} />
        </Button>
      </div>
      {(shippingLoading ||
        totalValidationLoading ||
        priceLoading ||
        saveSessionLoading) && <CircleLoader />}
    </>
  )
}

export default PlateType
